import { ClickAwayListener, Drawer, List } from '@material-ui/core';
import { MenuItem } from 'components';
import { Link } from 'react-router-dom';
import useStyles from './style';
import { IMainNavigationProps } from './types';

const MainNavigation = ({
  routes,
  openDrawer,
  onCloseDrawer,
  toggleDrawer,
}: IMainNavigationProps) => {
  const classes = useStyles();
  let openDrawerButtonClicked = false;
  const handleClickAway = () => {
    if (openDrawer && openDrawerButtonClicked) {
      openDrawerButtonClicked = false;
      return onCloseDrawer();
    }
    openDrawerButtonClicked = true;
    return null;
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Drawer
        className={classes.drawerMenu}
        anchor="left"
        aria-label="drawer-menu"
        open={openDrawer}
        variant="persistent"
        onClose={() => onCloseDrawer()}
      >
        <List className={classes.menuList}>
          {routes
            // não exibe as rotas no menu que tem o hidden = true no objeto meta
            .filter(router => !router?.meta?.hidden)
            .map(route => {
              return (
                <MenuItem
                  key={route.name}
                  component={Link}
                  route={route}
                  toggleDrawer={toggleDrawer}
                />
              );
            })}
        </List>
      </Drawer>
    </ClickAwayListener>
  );
};

export default MainNavigation;
